import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 325,
      borderRadius: theme.shape.borderRadius,
      border: theme.shape.borderGray70,
      background: COLORS.neutral.white,
      boxShadow: theme.shape.boxShadowMedium,
      padding: theme.spacing(1),
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    internalListItem: {},
    divider: {
      backgroundColor: COLORS.gray.gray70,
      margin: theme.spacing(0.5, 0),
    },
  }),
  { name: 'GenerationImproveList' }
);
